module.exports = __webpack_public_path__ + "img/Electric-Steering-Wheel.62ad5d0.jpg";